import { AppcuesService } from '@aca-new/app/shared/services/third-party-services/appcues/appcues.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

/**
 * @description
 * This guard is used to load the Appcues script and ensure that it is loaded before navigating to the route.
 * @param {ActivatedRouteSnapshot} _route {ActivatedRouteSnapshot} the route
 * @param {RouterStateSnapshot } _state the state
 * @returns {Observable} - resolve
 */
export function appcuesLoadGuard$(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<void> {
  const appcuesService = inject(AppcuesService);

  return appcuesService.appcuesLoader$().pipe(
    timeout(1000), // Resolve the observable after 1 second even if the script is not loaded
    catchError((): Observable<void> => {
      appcuesService.appcuesLoader$().subscribe();

      return of(void 0);
    })
  );
}
